import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-cotizacion-cabecera',
  templateUrl: './cotizacion-cabecera.component.html',
  styleUrls: ['./cotizacion-cabecera.component.scss'],
  providers: [SecurityService],
})
export class CotizacionCabeceraComponent implements OnInit {

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  optionsBodega: Array<any> = [];
  optionsSucursal: Array<any> = [];

  // Form
  formHeader: FormGroup

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private bodegaServ: BodegaService,
    private formatoProductoService: FormatoProductosService,
    private tipoDocumentoService: TipoDTEService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('GUIA-DESPACHO-CABECERA')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.loadBodegas()

    this.optionsSucursal = [
      { value: "1", label: "Sucursal 1" },
      { value: "2", label: "Sucursal 2" },
      { value: "3", label: "Sucursal 3" }
    ];

    this.createForms();
  }

  loadBodegas() {
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
    })
  }

  private createForms() {
    this.formHeader = this.fb.group({
      nroDoc: [null, [Validators.required]],
      fechaDoc: [null, [Validators.required]],
      fechaVencimiento: [null, [Validators.required]],
      bodega: [null, [Validators.required]],
      rutCliente: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      oc: [null, [Validators.required]],
      porcentajeDescuento: [null, [Validators.required, Validators.max(100)]],
    });
  }

}
